export default __webpack_public_path__ + "static/media/takeme_order.b34c7b03.png";